import '../scss/main.scss';
import initNav from './nav';
import initSliders from './elements/sliders';
import initSnapDots from './elements/snap-dots';
import initSignups from './elements/signup';
import initLoop from './elements/loop';
import initFaq from './elements/faq';
import initVideos from './elements/videos';
import initCompare from './elements/compare';
import initProcess from './elements/process';
import initPopups from './elements/popups';
import initHubspotFields from './elements/hubspot-fields';
import initHubspotLoader from './elements/hubspot-loader';
import initVideoEmbeds from './elements/video-embed';
import initAreasMap from './elements/areas-map';
import initStats from './elements/stats';
import { initReveal } from './reveal';
import initHeroVideo from './elements/hero-video';
import initHubspotAnalytics from './elements/hubspot-analytics';
import initTeamCards from './elements/team-cards';
import initArticle from './elements/article';
import initBlog from './elements/blog';
import initPortfolio from './elements/portfolio';
import initPdfViewers from './elements/pdf-viewer';
import initProject from './elements/project';
import initMoreCards from './elements/more-cards';

function initStickyState(header: HTMLElement): void {
	const update = (): void => {
		header.classList.toggle('is-scrolled', window.scrollY > 8);
	};

	update();
	window.addEventListener('scroll', update, { passive: true });
}

function boot(): void {
	initHubspotAnalytics();
	initSliders();
	initSnapDots();
	initSignups();
	initLoop();
	initFaq();
	initVideos();
	initCompare();
	initProcess();
	initPopups();
	initHubspotFields();
	initHubspotLoader();
	initVideoEmbeds();
	initAreasMap();
	initHeroVideo();
	initTeamCards();
	initArticle();
	initBlog();
	initPortfolio();
	initPdfViewers();
	initProject();
	initMoreCards();
	initStats();
	initReveal();

	const header = document.querySelector<HTMLElement>('[data-armada-header]');

	if (!header) {
		return;
	}

	initNav(header);
	initStickyState(header);
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', boot);
} else {
	boot();
}
